export const DEFAULT_SEARCH = { current: 1, pageSize: 20 } as const
